module.exports = __webpack_public_path__ + "img/offline.ab039a96.svg";